module.exports = __webpack_public_path__ + "static/media/confetti.6fcd2123.svg";